import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

import {environment} from '../../env';
import {FoodPreferences} from './food-preferences.models';

/**
 * Reads and writes a household's food preferences. These feed the LLM recipe
 * author and suggestion generator server-side (diet/dislikes are hard
 * constraints, cuisines/custom are soft steers).
 */
@Injectable({providedIn: 'root'})
export class FoodPreferencesService {
  constructor(private http: HttpClient) {}

  get(householdId: number): Observable<FoodPreferences> {
    return this.http.get<FoodPreferences>(
      `${environment.apiUrl}/households/${householdId}/food-preferences`,
    );
  }

  /** Replaces the household's full preference set; returns the normalized stored value. */
  save(householdId: number, prefs: FoodPreferences): Observable<FoodPreferences> {
    return this.http.put<FoodPreferences>(
      `${environment.apiUrl}/households/${householdId}/food-preferences`,
      prefs,
    );
  }
}
